module.exports = __webpack_public_path__ + "static/media/envelope-solid.adacefa8.svg";